module.exports = __webpack_public_path__ + "img/7.63d4fd6d.png";